import { capitalDesignTokens, createTypedSxStyles } from "@opengov/capital-mui-theme";

export const styles = createTypedSxStyles({
  searchResultRow: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: "8px",
    gap: "40px",
    height: capitalDesignTokens.foundations.units.unit4,
    textDecoration: "none",
    color: capitalDesignTokens.foundations.colors.gray1000,
    whiteSpace: "nowrap",
    cursor: "pointer",
    "&:hover, &.focused": {
      textDecoration: "none",
    },
  },
  searchResultTitle: {
    overflow: "hidden",
    textOverflow: "ellipsis",
  },
  searchResultDocumentType: {
    color: capitalDesignTokens.foundations.colors.gray700,
  },
  tooltipContent: {
    display: "flex",
    flexDirection: "column",
    px: "16px",
    py: "8px",
    gap: "4px",
    backgroundColor: capitalDesignTokens.foundations.colors.gray1000,
    minWidth: capitalDesignTokens.foundations.units.unit1 * 35,
    maxWidth: capitalDesignTokens.foundations.units.unit1 * 90,
  },
});
